import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators, NgForm} from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Inject} from '@angular/core';
///IDIOMAS
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { DropDownAnimation } from "app/animations";

//SERVICE
import { ODSService } from "../services/ods.service";
import { AuthService } from 'app/auth/auth.service';
import * as backInter from 'app/auth/auth-data.model';

import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { RegisterService } from "app/main/pagina/tools/gestUsu/services/registeruser.service";
import { seccionesMedir_Generico } from '../detail/cat-secciones';
import { DataSource } from '@angular/cdk/collections';
// import * as introJs from 'intro.js/intro.js';
export interface CompanyData {
  id: string,
  datosEmpresa:{
    nombreEmpresa: string
  }
}
export interface DialogData {
  userId:any,
  id_instituto:any,
}


@Component({
  selector: 'tableods-v2',
  templateUrl: './tableods-v2.component.html',
  styleUrls: ['./tableods-v2.component.scss'],
  animations : fuseAnimations
})
export class TableodsV2Component implements OnInit {
  todo : boolean = false;
  // displayedColumns: string[] = ['empresa', 'accion'];
  displayedColumns: string[] = ['empresa','creatDate','Autor','accion'];
  dataSource: any;
  // dataSource: MatTableDataSource<CompanyData>;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  cargando = true;

  institutoId: number;

  busqueda: string = "";
  paginaActual: number;
  totalEmpresas: number;
  nextPag: number;
  prevPag: number;
  contadorInicio: number;
  contadorFin: number;
  dataSourceUser: any;
  preFilterPlat:any[]=[{"datosEmpresaPlatform": 1},{"datosEmpresaPlatform": 2},{"datosEmpresaPlatform": 3}];
  postFilterPlat:any[]=[];
  idiomaActual:string;
  // introJS = introJs();
  checkedCGO=true;
  checkedSWFIT=true;
  checkedEXPRESS=true;
  constructor(
    private odsService: ODSService,
    private authService:AuthService,
    private router: Router, public snackBar: MatSnackBar,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private registerServices: RegisterService,
    public dialog: MatDialog,
  ) {


    this.idiomaActual = this.translateSrv.currentLang;
    lang_perfiles.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    // this.institutoId = infoUsu.institutoId;
    if(infoUsu.level == 3){
      this.institutoId = 0;
    }
    else{
      this.institutoId = infoUsu.institutoId;
    }
    localStorage.removeItem('urlResulIframe');
  }

  ngOnInit(): void {

    if(localStorage.getItem('busquedaEmpresa')){
      this.busqueda = localStorage.getItem('busquedaEmpresa');
      localStorage.removeItem('busquedaEmpresa');
    }
    this.getListaEmpresas(1);
  }

    borrarEmpresa(nombreEmpresa: string, empresaId: string){
      let mensajeTexto1 = 'MODALES.ELIMINAR.MENSAJETEXTO1';
      let mensajeTexto2 = 'MODALES.ELIMINAR.MENSAJETEXTO2';
      let confirmarEmpresa = 'MODALES.ELIMINAR.VALIDAR';
      let salir = 'MODALES.ELIMINAR.SALIR';
      let errorNombreEmpresa = 'MODALES.ELIMINAR.ERRORNOMBREEMPRESA';

      let mensaje = 'MODALES.ELIMINAR.MENSAJE';
      let cancelar = 'MODALES.ELIMINAR.CANCELAR';
      let confirmar = 'MODALES.ELIMINAR.CONFIRMAR';
      let success = 'MODALES.ELIMINAR.SUCCES';
      let cerrar = 'MODALES.ELIMINAR.CERRAR';

      this.translateSrv.get(mensajeTexto1).subscribe((res: string) => { mensajeTexto1 = res; });
      this.translateSrv.get(mensajeTexto2).subscribe((res: string) => { mensajeTexto2 = res; });
      this.translateSrv.get(confirmarEmpresa).subscribe((res: string) => { confirmarEmpresa = res; });
      this.translateSrv.get(salir).subscribe((res: string) => { salir = res; });
      this.translateSrv.get(errorNombreEmpresa).subscribe((res: string) => { errorNombreEmpresa = res; });

      this.translateSrv.get(mensaje).subscribe((res: string) => { mensaje = res; });
      this.translateSrv.get(cancelar).subscribe((res: string) => { cancelar = res; });
      this.translateSrv.get(confirmar).subscribe((res: string) => { confirmar = res; });
      this.translateSrv.get(success).subscribe((res: string) => { success = res; });
      this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });

      Swal.fire({
        title: mensajeTexto1+'<font color="red">'+nombreEmpresa+'</font>'+mensajeTexto2,
        icon: 'info',
        input:'text',
        width: 600,
        showCancelButton: true,
  reverseButtons: true,


        cancelButtonText: salir,
        confirmButtonText: confirmarEmpresa
      })
      .then( (borrar) => {
        console.log(borrar);
        if (borrar.value==nombreEmpresa) {
          Swal.fire({
            title: mensaje + nombreEmpresa,
            icon: 'warning',
            showCancelButton: true,
  reverseButtons: true,
            width: 600,


            cancelButtonText: cancelar,
            confirmButtonText: confirmar
          })
          .then( (borrar) => {
            console.log(borrar);
            if (borrar.value) {
              this.odsService.borrarEmpresa( empresaId )
              .subscribe( borrado => {
                console.log(borrado);
                Swal.fire({
                icon: 'success',
                title: success,
                showConfirmButton: true,

                confirmButtonText: cerrar
                })
                this.getListaEmpresas(1);
              });
            }
          });
        }
        else{
          if(!borrar.dismiss){
            Swal.fire({
            icon: 'error',
            title: errorNombreEmpresa,
            showConfirmButton: true,

            confirmButtonText: cerrar
            })
          }

        }
      });
    }

    getListaEmpresas(pagina?:number){
      if(pagina){
        this.cargando = true;
        let datos:any = {institutoId:this.institutoId};
        if(this.busqueda.length > 0){
          datos.search = this.busqueda
          localStorage.setItem('busquedaEmpresa', this.busqueda);
        }
        else{
          localStorage.removeItem('busquedaEmpresa');
        }
        if (this.preFilterPlat.length>0) {
          let platForm:any[]=[];
          this.preFilterPlat.forEach(platform => {
            platForm.push({"datosEmpresa.platform": platform.datosEmpresaPlatform});
          });
          console.log("platForm ya construida",platForm);

          datos.platforms = platForm
        }

        console.log("Datos",datos);
        if (this.preFilterPlat.length>0) {
          this.odsService.getListaEmpresas(datos,pagina).subscribe( (respuesta:backInter.getListaEmpresas) => {
          console.log(respuesta);
          this.dataSource = respuesta.data.docs;
          this.totalEmpresas = respuesta.data.totalDocs;
          this.nextPag = respuesta.data.nextPage;
          this.prevPag = respuesta.data.prevPage;
          this.contadorInicio = respuesta.data.pagingCounter;
          this.contadorFin = this.contadorInicio + (respuesta.data.limit - 1);
          if(this.contadorFin > this.totalEmpresas){
            this.contadorFin = this.totalEmpresas;
          }
          this.cargando = false;
          // this.introJS.setOptions({
          //   tooltipClass: 'customTooltip',
          //   highlightClass: 'customHighlight',
          //   exitOnOverlayClick: false,
          //   disableInteraction: false,
          //   nextLabel: 'Continuar',
          //   prevLabel: 'Anterior',
          //   doneLabel: 'Cerrar',
          //   steps: [
          //     {
          //       intro: "Bienvenido a cultural go",
          //     },
          //     {
          //       element: document.querySelector('.step1'),
          //       intro: "En esté campo podras  ingresar el nombre de la empresa ",
          //       position: 'bottom',
          //     },
          //     {
          //       element: document.querySelector('#typePlatform'),
          //       intro: "Aqui puedes filtrar las empresa por tipo de plataforma ",
          //       position: 'right',
          //     },
          //     {
          //       element: document.querySelector('#Paginator'),
          //       intro: "Aqui puedes cambiar de pagina para continuar ",
          //       position: 'right',
          //     },
          //     {
          //       element: document.querySelector('#Emeepta'),
          //       intro: "Aqui mostrara las empresas encontradas ",
          //       position: 'left',
          //     },
          //
          //   ]
          // });
          // console.log("introJS",this.introJS);

      // this.introJS.start();

        });
      }
      }
    }

    private getCompaniesArray() {
      let datos = {institutoId:this.institutoId};
      // console.log(datos);
      this.odsService.getCompanies(datos)
      .subscribe(response => {
        console.log(response);

      this.dataSource = new MatTableDataSource(response['data']);

      //codigo para utilizar la columna del nombre de empresa para realizar busquedas
      this.dataSource.filterPredicate = (data, filterValue: string)  => {
        const accumulator = (currentTerm, key) => {
          return key === 'datosEmpresa' ? currentTerm + data.datosEmpresa.nombreEmpresa : currentTerm + data[key];
        };
        const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
        // console.log(dataStr);
        // Transform the filterValue by converting it to lowercase and removing whitespace.
        const transformedFilter = filterValue.trim().toLowerCase();
        return dataStr.indexOf(transformedFilter) !== -1;
      };

      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      this.cargando = false;

      }, error => {
        console.log("error", error);
      })
    }

    applyFilter(filterValue: string) {
      this.dataSource.filter = filterValue.trim().toLowerCase();

      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    }

    private showDetail(){
      this.todo = !this.todo;
    }

    private getEnterpriseDetail(idEnterprise : string) {

      this.router.navigate(['/companies/detail',idEnterprise]);

      /*this.odsService.getEnterpriseDetail(idEnterprise)
      .subscribe(response => {

      console.log(response['message']);
      console.log(response['data']);
       //let result: Institute[] = response['Institutos'];
       //this.institutes = result;
       //this.dataSource = new MatTableDataSource(response['data']);


      }, error => {
        console.log("error", error);
      })*/
    }

    infoPaquete(idEnterprise: string){
      this.router.navigate(['/companies/profile',idEnterprise]);
    }

    private statusSurvey(idEnterprise : string) {
      /*this.odsService.getEnterpriseDetail(idEnterprise)
      .subscribe(response => {
        console.log("getEnterpriseDeailt");
        console.log(response);
        localStorage.setItem('codigoDeProyecto',''+this.enterpriseData['codigoProyecto']);
      }, error => {
        console.log("error", error);
      });*/

      this.router.navigate(['survey-status',idEnterprise]);
    }


    private showManagerTI(idEnterprise : string) {

      this.router.navigate(['/requirements',idEnterprise]);
    }

    private showReqTec(idEnterprise : string) {
      this.router.navigate(['/companies/requirement-steps',idEnterprise]);
    }

    private showSurveyStatus(idEnterprise : string, instituto) {
      localStorage.removeItem('BACK_PORTAL');
      localStorage.setItem('instituto_id',''+instituto);
      localStorage.setItem('instituto_Empresa',''+instituto);
      this.router.navigate(['/companies/survey-status',idEnterprise]);
    }

     emaildetails(idEnterprise,nameEmpresa) {
       localStorage.setItem('nameEmpresa_HistoryEmail',''+nameEmpresa);
      this.router.navigate(['companies/email-history/',idEnterprise]);
    }

    private editCompany(idEnterprise : string) {

      // this.router.navigate(['/profile-creator/company/edit',idEnterprise]);
      this.router.navigate(['/companies/edit',idEnterprise]);
    }

    private gestorStatus(idEnterprise : string) {
      // this.router.navigate(['/companies/status',idEnterprise]);
      localStorage.setItem('empresaIDInfo', idEnterprise);
      this.router.navigate(['/companies/status'], { state: {idEmpresa:idEnterprise} });
    }

    autologin(userId:string){
      console.log("Id autologin "+userId);
      Swal.showLoading();
      this.getUsuariosEmpresas(userId);
      /*let texto = 'MODALES.MENSAJES.WIZARD.NOM35.CENTROS.AUTOLOGIN.INFOODS';
      let rspSi = 'MODALES.ACCIONES.aceptar';
      let rspNo = 'MODALES.ACCIONES.cancelar';
      this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
      this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
      this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
  reverseButtons: true,


        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          this.authService.logout(null,userId);
        }
      });*/
    }

    getUsuariosEmpresas(respuesta: string){

       let userId=respuesta;
      this.registerServices.getUsuariosEmpresas(respuesta,this.institutoId,1).subscribe((response:any) => {
        if(response.success){
          // if (response.usuarios.length == 1) {
            console.log(response);
            Swal.close();
            this.openDialog(respuesta);
          // }
          // else{
          //   let texto = 'MODALES.MENSAJES.WIZARD.NOM35.CENTROS.AUTOLOGIN.INFOODS';
          //   let rspSi = 'MODALES.ACCIONES.aceptar';
          //   let rspNo = 'MODALES.ACCIONES.cancelar';
          //   this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
          //   this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
          //   this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
          //   Swal.close();
          //
          //     Swal.fire({
          //       title: texto,
          //       icon: 'warning',
          //       showCancelButton: true,
          //
          //
          //       confirmButtonText: rspSi,
          //       cancelButtonText: rspNo
          //     }).then((result) => {
          //     if (result.value) {
          //       this.authService.logout(null,userId);
          //     }
          //   });
          //
          //
          // }

        }

      }, error => {
        console.log(error);
      })
    }

    openDialog(idsurvey?): void {
      let dataModal: any;
      const dialogRef = this.dialog.open(AutologinDialogV2, {
        // width: '1500px', height: '350px',
        width: '60%',
        data: {
          userId:idsurvey,
          id_instituto:this.institutoId,
        }
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    }
    enterpriseData : any;

    getDetail(idEnterprise : string) {
      this.odsService.getEnterpriseDetail(idEnterprise)
      .subscribe(response => {
        console.log("getEnterpriseDeailt");
        console.log(response);
        localStorage.setItem('codigoDeProyecto',''+this.enterpriseData['codigoProyecto']);


      }, error => {
        console.log("error", error);
      });
    }


    filterPlatform(event,typePlat){
      console.log(typePlat);

      switch (typePlat) {
        case 1: case 2: case 3:
          if (event['checked']) {
            this.preFilterPlat.push({"datosEmpresaPlatform" : typePlat});
          }else{
            if (this.preFilterPlat.length>1) {
              let indexPlatform= this.preFilterPlat.findIndex(item=> item.datosEmpresaPlatform==typePlat);
              if (indexPlatform!=-1) {
                console.log("lo encontro",indexPlatform);
                this.preFilterPlat.splice(indexPlatform,1);
              }
            }else{
              let cerrar = 'MODALES.ELIMINAR.CERRAR';
        this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
              let text = 'CONSULTATABLA.WARNI_SELCT_CHECK';
        this.translateSrv.get(text).subscribe((res: string) => { text = res; });
              setTimeout(() => {
              switch (typePlat) {
                case 1:this.checkedCGO=true;break;
                case 2:this.checkedEXPRESS=true;break;
                case 3:this.checkedSWFIT=true;break;
                default:
                  break;
              }
            }, 1000);
              Swal.fire({
              icon: 'warning',
              title: text,
              showConfirmButton: true,
              confirmButtonText: cerrar
              })

            }
          }
          this.getListaEmpresas(1);
          break;

        default:
          break;
      }
      console.log('event',event['checked']);

    }

  }




  @Component({
    selector: 'AutologinDialogV2',
    templateUrl: './dialog_autologin.login.component.html',
    styleUrls: ['./tableods-v2.component.scss'],
    animations : fuseAnimations
  })


  export class AutologinDialogV2 {

    //private _unsubscribeAll: Subject<any>;
    informacion:any;
    cargandoCitas:boolean=true;
    dataSource:any;
    displayedColumns: string[] = ['correo', 'tipousu', 'accion'];
    constructor(
      private _formBuilder: FormBuilder,
      private translateSrv: TranslateService,
      private _fuseTranslationLoaderService: FuseTranslationLoaderService,
      public authService: AuthService,
      private registerServices: RegisterService,
      public dialogRef: MatDialogRef<AutologinDialogV2>,
      @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) {
      lang_perfiles.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });
      lang_modales.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });

      console.log(data);
      this.getUsuariosEmpresas(data.userId,data.id_instituto,2);
     }
    usuariosOrdenador_tmp: []=[];
    usuariosOrdenador: any[]=[];
    orderLevel=[1,10,8,4,5,12,13];
    getUsuariosEmpresas(respuesta: string, id_instituto,bandera){
      this.usuariosOrdenador=[];
      let userId=respuesta;
      this.registerServices.getUsuariosEmpresas(respuesta,id_instituto,bandera).subscribe((response:any) => {
       if(response.success){
        let aux_array:[];
        console.log(response);
        for(let i=0;  i < this.orderLevel.length; i++){
          for(let j=0; j < response.usuarios.length; j++){
            if(response.usuarios[j].level == this.orderLevel[i] ){
              this.usuariosOrdenador.push(response.usuarios[j]);
            }
          }
        }
        console.log("nuevo orden");
        console.log(this.usuariosOrdenador);
        //this.dataSource=response.usuarios;
        this.usuariosOrdenador.sort();
        this.dataSource=this.usuariosOrdenador;
       }

      }, error => {
        console.log(error);
      });
    }

   autologin(user?:string, password?:string){
    let texto = 'MODALES.MENSAJES.WIZARD.NOM35.CENTROS.AUTOLOGIN.INFO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
    this.dialogRef.close();
      let datosAutoLog = {
        user,
        password,
      };
      this.authService.logout(datosAutoLog, true);

    /*Swal.fire({
      title: texto,
      icon: 'warning',
      showCancelButton: true,
  reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {

        this.dialogRef.close();
        let datosAutoLog = {
          user,
          password,
        };
        // console.log(datosAutoLog);
        this.authService.logout(datosAutoLog);
      }
    });*/
  }




  }
